import { Stagger, StaggerItem } from "../common/Reveal";
import { SectionHeading } from "../common/SectionHeading";
import { whyFrontx } from "../../data/content";

export const WhyFrontxGrid = ({ dark = false }) => (
    <section className={`relative ${dark ? "bg-navy grain" : "bg-[#f8fafc]"}`} data-testid="why-frontx">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
            <SectionHeading
                dark={dark}
                align="center"
                overline="Why FRONTX"
                title="Why Businesses Choose FRONTX"
                subtitle="A single integrated partner combining scalable manpower solutions with construction and project execution capabilities across India."
            />
            <Stagger className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {whyFrontx.map((w) => (
                    <StaggerItem key={w.title}>
                        <div className={`group h-full p-7 rounded-sm border transition-all duration-300 hover:-translate-y-1 ${
                            dark ? "bg-slate-800 border-white/10 hover:border-brand" : "bg-white border-slate-200 hover:border-brand"
                        }`}>
                            <div className="h-12 w-12 rounded-sm grid place-items-center bg-brand/15 group-hover:bg-brand transition-colors duration-300">
                                <w.icon size={26} weight="duotone" className="text-brand group-hover:text-white transition-colors duration-300" />
                            </div>
                            <h3 className={`mt-5 font-display font-bold text-lg tracking-tight ${dark ? "text-white" : "text-navy"}`}>{w.title}</h3>
                            <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"}`}>{w.desc}</p>
                        </div>
                    </StaggerItem>
                ))}
            </Stagger>
        </div>
    </section>
);
